module.exports = __webpack_public_path__ + "assets/8d5270d8848217764c27963fa5287e80.svg";